import React from "react";
import Layout from "../components/layout/Layout";
import SEO from "../components/SEO";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import HomepageTop from "../components/HomepageTop";
import ComparisonCard from "../components/ComparisonCard";
import Slider from "react-slick";
import BoardSlide from "../components/BoardSlide";
import PostsList from "../components/PostsList";
import HomepageSidebar from "../components/layout/HomepageSidebar";

const Next = ({ onClick }) => (
  <div
    className={`cursor-pointer text-indigo-700 bg-indigo-200 right-0 absolute top-0 w-10 h-8 justify-center items-center z-10`}
    style={{ display: "flex" }}
    onClick={onClick}
  >
    <i className="fa fa-arrow-right" />
  </div>
);

const Prev = ({ onClick }) => (
  <div
    className={`cursor-pointer text-indigo-700 bg-indigo-200 left-0 absolute top-0 w-10 h-8 justify-center items-center z-10`}
    style={{ display: "flex" }}
    onClick={onClick}
  >
    <i className="fa fa-arrow-left" />
  </div>
);

const IndexPage = ({ data }) => {
  const postsAvailable = data && data.allMdx && data.allMdx.edges;

  const mcus = data.allMarkdownRemark.edges.filter(
    edge => edge.node.mcuFrontmatter.category === "microcontroller"
  );
  const sbcs = data.allMarkdownRemark.edges.filter(
    edge => edge.node.sbcFrontmatter.category === "single-board-computer"
  );

  //TODO: Move this into a function (in util/functions.js)
  const mcuComparisons = data.comparisons.childDataYaml.microcontrollers.homepage.map(
    boards => {
      return boards.map(boardSlug => {
        const mcuEdge = mcus.find(({ node }) => node.fields.slug === boardSlug);
        const {
          id,
          mcuFrontmatter: {
            title,
            featured_image: { thumbnail },
          },
        } = mcuEdge.node;

        return {
          id,
          title,
          thumbnail,
        };
      });
    }
  );
  const sbcComparisons = data.comparisons.childDataYaml.singleBoardComputers.homepage.map(
    boards => {
      return boards.map(boardSlug => {
        const sbcEdge = sbcs.find(({ node }) => node.fields.slug === boardSlug);
        const {
          id,
          sbcFrontmatter: {
            title,
            featured_image: { thumbnail },
          },
        } = sbcEdge.node;

        return {
          id,
          title,
          thumbnail,
        };
      });
    }
  );
  // console.log(sbcComparisons);
  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    adaptiveHeight: true,
    nextArrow: <Next />,
    prevArrow: <Prev />,
    className: "h-64",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Layout>
      <SEO title="Home" />
      {postsAvailable && (
        <>
          <section>
            <h2 className="border-b border-neutral text-2xl mb-8 font-bold pb-1">
              Featured Posts
            </h2>
            <div className="grid md:grid-cols-3 md:grid-rows-2 grid-cols-1 grid-rows-3 gap-4">
              {(data.allMdx.edges.slice(0, 3) || []).map(
                ({ node: { id, frontmatter, fields } }, i) => (
                  <HomepageTop
                    key={id}
                    title={frontmatter.title}
                    date={frontmatter.date}
                    img={frontmatter.featured_image.img}
                    path={`/blog/${fields.slug}`}
                    category={frontmatter.category}
                    isFirst={i === 0}
                  />
                )
              )}
            </div>
          </section>
          <div className="mt-12 grid gap-4 grid-cols-1 lg:grid-cols-3">
            <section className="col-span-1 lg:col-span-2">
              <h2 className="border-b border-neutral text-2xl mb-8 font-bold pb-1">
                Recent News
              </h2>
              <PostsList edges={data.news.edges} />
            </section>
            <HomepageSidebar />
          </div>
          {/* <section>
            <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
              Featured Boards
            </h2>
            <div className="container mx-auto">
              <Slider {...sliderSettings}>
                {(mcus || []).map(({ node }, i) => (
                  <BoardSlide
                    key={i}
                    title={node.mcuFrontmatter.title}
                    thumbnail={node.mcuFrontmatter.featured_image.thumbnail}
                    path={`/microcontrollers/${node.fields.slug}`}
                  />
                ))}
              </Slider>
            </div>
          </section> */}
          <section>
            <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
              Microcontroller Comparisons
            </h2>
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {(mcuComparisons || []).map((comparison, i) => (
                <ComparisonCard
                  key={i}
                  path={`/compare/microcontrollers`}
                  category="microcontroller"
                  boards={comparison}
                />
              ))}
            </div>
          </section>
          <section>
            <h2 className="border-b border-neutral text-2xl my-8 font-bold pb-1">
              Single-Board Computer Comparisons
            </h2>
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {(sbcComparisons || []).map((comparison, i) => (
                <ComparisonCard
                  key={i}
                  path={`/compare/single-board-computers`}
                  category="single-board-computer"
                  boards={comparison}
                />
              ))}
            </div>
          </section>
        </>
      )}
    </Layout>
  );
};

export const homePagePostsQuery = graphql`
  query {
    allMdx(
      sort: { order: DESC, fields: frontmatter___date }
      filter: { fields: { slug: { ne: "privacy-policy" } } }
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            date(formatString: "MMM DD, YYYY")
            title
            category
            featured_image {
              img {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }

    news: allMdx(
      sort: { order: DESC, fields: frontmatter___date }
      filter: {
        fields: { slug: { ne: "privacy-policy" } }
        frontmatter: { category: { eq: "News" } }
      }
      limit: 5
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            date(formatString: "MMM DD, YYYY")
            title
            category
            featured_image {
              thumbnail: img {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }

    allMarkdownRemark {
      edges {
        node {
          id
          excerpt(pruneLength: 80)
          ...MCUFrontmatter
          ...SBCFrontmatter
          fields {
            slug
          }
        }
      }
    }
    comparisons: file(relativePath: { eq: "comparisons.yaml" }) {
      childDataYaml {
        microcontrollers {
          homepage
        }
        singleBoardComputers {
          homepage
        }
      }
    }
  }
`;

export default IndexPage;
